// Server timestamps arrive as naive UTC strings ("2026-10-12 07:38:17").
// new Date() parses those as LOCAL time — every clock in the app was off
// by the UTC offset. Parse them explicitly as UTC.
export function parseUtc(ts) {
  if (!ts) return null;
  if (ts instanceof Date) return ts;
  let s = String(ts).trim();
  if (s.includes(' ') && !s.includes('T')) s = s.replace(' ', 'T');
  // No timezone marker → treat as UTC
  if (!/Z$|[+-]\d{2}:?\d{2}$/.test(s)) s += 'Z';
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}
